import React from 'react';
import { ContentTemplate, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';

import { ResultListing } from '../../../modules/result/@candidate';

const CoordinatorResult = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('exam->>ResultListing.Results')} />

      <ContentTemplate type="full">
        <ResultListing userRole="coordinator" header={t('exam->>ResultListing.Exam Results')} />
      </ContentTemplate>
    </>
  );
};

export default CoordinatorResult;
